// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// eslint-disable-next-line spire/fenced-imports
import { tooltipDefaultProps } from "@awc/App/Components/FloatingTooltip/presentationProps";
import { FloatingDelayGroup } from "@floating-ui/react";
import React, { FC, ReactNode } from "react";

export interface XngAppProviderProps {
    children: (ReactNode | Element)[];
}

const XngAppProvider: FC<XngAppProviderProps> = ({ children }) => {
    return <FloatingDelayGroup delay={tooltipDefaultProps.groupDelay}>{children}</FloatingDelayGroup>;
};

export default XngAppProvider;
